import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { Link as RouterLink } from "react-router-dom"

import ThemeConsumer from "../ThemeConsumer"
import Typograph from "../../../components/Typograph"

const CardButton = ({
  className,
  id,
  icons,
  iconName,
  onClick,
  title,
  to,
  theme,
  isFirst
}) => {
  const containerClasses = classnames(
    { [theme.ml6]: !isFirst },
    theme.pt8,
    theme.pb7,
    theme.px6,
    theme.cardButton,
    className
  )

  const IconComponent = icons[iconName] || null

  return (
    <RouterLink className={containerClasses} to={to} onClick={onClick} id={id}>
      {IconComponent && <IconComponent />}
      <Typograph
        htmlTag="h2"
        preset="h2"
        size="medium"
        color="outer_space"
        weight="bold"
      >
        {title}
      </Typograph>
    </RouterLink>
  )
}

CardButton.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  icons: PropTypes.object.isRequired,
  iconName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  theme: PropTypes.object,
  isFirst: PropTypes.bool
}

export default ThemeConsumer("UICardButton")(CardButton)



// WEBPACK FOOTER //
// ./src/shared/components/CardButton/index.js